var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronzeMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4002_3188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4305 31.3235C15.642 33.488 17.029 36.0954 17.5085 38.6077C17.6089 39.1339 16.8016 39.9588 16.2733 39.8697C13.7513 39.4443 11.1147 38.1135 8.90323 35.9491C6.69176 33.7847 5.3047 31.1772 4.82519 28.6649C4.7248 28.1387 5.53215 27.3138 6.06039 27.4029C8.58245 27.8283 11.219 29.159 13.4305 31.3235Z",
    fill: "url(#paint0_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4305 31.3235C15.642 33.488 17.029 36.0954 17.5085 38.6077C17.6089 39.1339 16.8016 39.9588 16.2733 39.8697C13.7513 39.4443 11.1147 38.1135 8.90323 35.9491C6.69176 33.7847 5.3047 31.1772 4.82519 28.6649C4.7248 28.1387 5.53215 27.3138 6.06039 27.4029C8.58245 27.8283 11.219 29.159 13.4305 31.3235Z",
    fill: "url(#paint1_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4293 26.1974C18.2026 29.6629 18.8153 33.3273 18.3836 36.5159C18.2932 37.1836 17.0004 37.8451 16.4059 37.5277C13.5674 36.0126 10.9539 33.3718 9.18081 29.9063C7.40767 26.4409 6.79483 22.7764 7.22659 19.5879C7.31698 18.9202 8.60973 18.2587 9.20424 18.5761C12.0427 20.0912 14.6561 22.7319 16.4293 26.1974Z",
    fill: "url(#paint2_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19287 23.3858C7.42718 25.5284 8.08032 27.7557 9.18081 29.9064C10.954 33.3719 13.5674 36.0127 16.4059 37.5278C17.0003 37.8451 18.2931 37.1836 18.3836 36.516C18.8153 33.3275 18.2026 29.663 16.4293 26.1975C15.3852 24.1568 14.0495 22.4026 12.5483 20.9954L7.19287 23.3858Z",
    fill: "url(#paint3_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5695 31.3235C34.358 33.488 32.971 36.0954 32.4914 38.6077C32.3911 39.1339 33.1984 39.9588 33.7266 39.8697C36.2487 39.4443 38.8853 38.1135 41.0967 35.9491C43.3082 33.7847 44.6953 31.1772 45.1748 28.6649C45.2752 28.1387 44.4678 27.3138 43.9396 27.4029C41.4175 27.8283 38.781 29.159 36.5695 31.3235Z",
    fill: "url(#paint4_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5695 31.3235C34.358 33.488 32.971 36.0954 32.4914 38.6077C32.3911 39.1339 33.1984 39.9588 33.7266 39.8697C36.2487 39.4443 38.8853 38.1135 41.0967 35.9491C43.3082 33.7847 44.6953 31.1772 45.1748 28.6649C45.2752 28.1387 44.4678 27.3138 43.9396 27.4029C41.4175 27.8283 38.781 29.159 36.5695 31.3235Z",
    fill: "url(#paint5_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5705 26.1974C31.7972 29.6629 31.1845 33.3273 31.6162 36.5159C31.7066 37.1836 32.9994 37.8451 33.5939 37.5277C36.4324 36.0126 39.0459 33.3718 40.819 29.9063C42.5921 26.4409 43.205 22.7764 42.7732 19.5879C42.6828 18.9202 41.3901 18.2587 40.7956 18.5761C37.9571 20.0912 35.3437 22.7319 33.5705 26.1974Z",
    fill: "url(#paint6_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8069 23.3858C42.5726 25.5284 41.9195 27.7557 40.819 29.9064C39.0458 33.3719 36.4324 36.0127 33.5939 37.5278C32.9995 37.8451 31.7067 37.1836 31.6162 36.516C31.1845 33.3275 31.7972 29.663 33.5705 26.1975C34.6146 24.1568 35.9503 22.4026 37.4515 20.9954L42.8069 23.3858Z",
    fill: "url(#paint7_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 49.9999C33.6105 49.9999 40.5908 43.0197 40.5908 34.4091C40.5908 25.7986 33.6105 18.8184 25 18.8184C16.3894 18.8184 9.40918 25.7986 9.40918 34.4091C9.40918 43.0197 16.3894 49.9999 25 49.9999Z",
    fill: "url(#paint8_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 46.8361C31.8632 46.8361 37.4269 41.2724 37.4269 34.4091C37.4269 27.5459 31.8632 21.9822 25 21.9822C18.1367 21.9822 12.573 27.5459 12.573 34.4091C12.573 41.2724 18.1367 46.8361 25 46.8361Z",
    fill: "url(#paint9_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 45.0777C30.892 45.0777 35.6686 40.3012 35.6686 34.4091C35.6686 28.517 30.892 23.7405 24.9999 23.7405C19.1078 23.7405 14.3313 28.517 14.3313 34.4091C14.3313 40.3012 19.1078 45.0777 24.9999 45.0777Z",
    fill: "url(#paint10_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40918 34.4093C9.40918 43.0198 16.3894 50 25 50C33.6106 50 40.5908 43.0198 40.5908 34.4093C40.5908 34.3488 40.5892 34.2887 40.5885 34.2283H9.41143C9.41075 34.2887 9.40918 34.3488 9.40918 34.4093Z",
    fill: "url(#paint11_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3725 49.3773C34.2851 47.9446 38.1943 44.1598 39.7995 39.3232L32.2061 31.7298L30.4942 31.8138L25.874 27.1936L20.2432 40.248L29.3725 49.3773Z",
    fill: "url(#paint12_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3929 31.0215L28.3353 30.2828C28.0509 30.214 27.8024 30.0416 27.6384 29.7992L25.8758 27.1938C25.6626 26.8787 25.336 26.7096 25 26.6824C24.6639 26.7096 24.3372 26.8787 24.1241 27.1938L22.3615 29.7992C22.1976 30.0416 21.9491 30.214 21.6646 30.2828L18.607 31.0215C17.7776 31.2219 17.432 32.2118 17.9563 32.8849L19.8896 35.3663C20.0694 35.5972 20.1566 35.8868 20.1341 36.1786L19.8918 39.3147C19.8261 40.1654 20.6607 40.8001 21.463 40.5093L24.4203 39.4376C24.6072 39.3698 24.8065 39.3524 25 39.3824C25.1935 39.3525 25.3927 39.3699 25.5796 39.4376L28.5369 40.5093C29.3391 40.8 30.1738 40.1654 30.1081 39.3147L29.8658 36.1786C29.8433 35.8868 29.9305 35.5972 30.1103 35.3663L32.0436 32.8849C32.5679 32.2118 32.2223 31.2219 31.3929 31.0215Z",
    fill: "url(#paint13_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5796 39.4376L28.537 40.5093C29.3391 40.8 30.1738 40.1654 30.1081 39.3147L29.8659 36.1786C29.8433 35.8868 29.9306 35.5972 30.1104 35.3663L32.0436 32.8849C32.568 32.2119 32.2224 31.2219 31.3929 31.0215L28.3354 30.2828C28.051 30.214 27.8024 30.0416 27.6384 29.7992L25.8759 27.1938C25.6626 26.8787 25.3361 26.7096 25 26.6824V39.3824C25.1935 39.3524 25.3928 39.3698 25.5796 39.4376Z",
    fill: "url(#paint14_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3928 31.0214L28.3353 30.2827C28.2309 30.2575 28.1314 30.218 28.0392 30.1665L20.2449 40.2482C20.5507 40.5437 21.0119 40.6728 21.4629 40.5093L24.4203 39.4376C24.6071 39.3698 24.8064 39.3524 24.9999 39.3824C25.1934 39.3525 25.3926 39.3699 25.5795 39.4376L28.5368 40.5093C29.339 40.8 30.1737 40.1654 30.108 39.3147L29.8658 36.1786C29.8432 35.8868 29.9305 35.5972 30.1103 35.3663L32.0435 32.8849C32.5678 32.2117 32.2222 31.2218 31.3928 31.0214Z",
    fill: "url(#paint15_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.607 31.0214L21.6646 30.2827C21.769 30.2575 21.8684 30.218 21.9606 30.1665L29.755 40.2482C29.4492 40.5437 28.9879 40.6728 28.5369 40.5093L25.5796 39.4376C25.3927 39.3698 25.1934 39.3524 25 39.3824C24.8064 39.3525 24.6072 39.3699 24.4203 39.4376L21.463 40.5093C20.6608 40.8 19.8261 40.1654 19.8918 39.3147L20.1341 36.1786C20.1566 35.8868 20.0694 35.5972 19.8896 35.3663L17.9563 32.8849C17.432 32.2117 17.7776 31.2218 18.607 31.0214Z",
    fill: "url(#paint16_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7932 31.73C17.6478 32.0966 17.6827 32.5336 17.9563 32.8849L19.8895 35.3663C20.0694 35.5971 20.1566 35.8867 20.1341 36.1785L19.8918 39.3147C19.8261 40.1654 20.6607 40.8001 21.463 40.5093L24.4203 39.4375C24.6072 39.3698 24.8065 39.3523 24.9999 39.3823C25.1935 39.3524 25.3927 39.3699 25.5795 39.4375L28.5369 40.5093C29.3391 40.8 30.1738 40.1654 30.1081 39.3147L29.8658 36.1785C29.8533 36.0166 29.8757 35.8558 29.9279 35.7049L17.7932 31.73Z",
    fill: "url(#paint17_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2079 31.73C32.3533 32.0966 32.3185 32.5336 32.0448 32.8849L30.1116 35.3663C29.9318 35.5971 29.8445 35.8867 29.8671 36.1785L30.1093 39.3147C30.175 40.1654 29.3403 40.8001 28.5381 40.5093L25.5808 39.4375C25.3939 39.3698 25.1946 39.3523 25.0012 39.3823C24.8077 39.3524 24.6084 39.3699 24.4216 39.4375L21.4642 40.5093C20.6621 40.8 19.8274 40.1654 19.893 39.3147L20.1353 36.1785C20.1478 36.0166 20.1254 35.8558 20.0732 35.7049L32.2079 31.73Z",
    fill: "url(#paint18_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 18.8184C24.9352 18.8184 24.871 18.82 24.8065 18.8208L22.4004 21.2269L39.9652 38.7917C40.3717 37.4013 40.5907 35.9308 40.5907 34.409C40.5907 25.7986 33.6105 18.8184 24.9999 18.8184Z",
    fill: "url(#paint19_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5881 0.32666V8.56196L24.9999 17.9737L34.4117 8.56196V0.32666H15.5881Z",
    fill: "url(#paint20_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5881 0.32666V2.8896L24.9684 12.2699C24.9858 12.2872 25.014 12.2872 25.0314 12.2699L34.4117 2.8896V0.32666H15.5881Z",
    fill: "url(#paint21_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 13.7528C24.6119 13.7528 24.2239 13.6051 23.9286 13.3097L15.5881 4.96924V8.56198L24.9999 17.9737L34.4117 8.56198V4.96924L26.0712 13.3097C25.7759 13.605 25.3879 13.7528 24.9999 13.7528Z",
    fill: "url(#paint22_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5881 0.32666V2.8896L24.9684 12.2699C24.9858 12.2872 25.014 12.2872 25.0314 12.2699L34.4117 2.8896V0.32666H15.5881Z",
    fill: "url(#paint23_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 13.7528C24.6119 13.7528 24.2239 13.6051 23.9286 13.3097L15.5881 4.96924V8.56198L24.9999 17.9737L34.4117 8.56198V4.96924L26.0712 13.3097C25.7759 13.605 25.3879 13.7528 24.9999 13.7528Z",
    fill: "url(#paint24_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 13.7528C25.3879 13.7528 25.7759 13.6051 26.0712 13.3097L34.4117 4.96924V8.56198L24.9999 17.9737L15.5881 8.56198V4.96924L23.9286 13.3097C24.2239 13.605 24.612 13.7528 24.9999 13.7528Z",
    fill: "url(#paint25_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9677 15.8359L15.9585 7.82666C15.3579 7.22607 14.384 7.22607 13.7834 7.82666C13.1829 8.42725 13.1829 9.40107 13.7834 10.0017L24.9997 21.2181L36.2161 10.0018C36.8167 9.40117 36.8167 8.42735 36.2161 7.82676C35.6155 7.22617 34.6417 7.22617 34.0411 7.82676L26.0319 15.836C25.4618 16.406 24.5377 16.406 23.9677 15.8359Z",
    fill: "url(#paint26_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7833 7.8449L23.8187 17.8803C24.4709 18.5325 25.5285 18.5325 26.1807 17.8803L36.216 7.8449C36.219 7.84196 36.2213 7.83872 36.2243 7.83578C36.2214 7.83284 36.219 7.8296 36.216 7.82666C35.6154 7.22607 34.6416 7.22607 34.041 7.82666L26.0318 15.8359C25.4618 16.4059 24.5376 16.4059 23.9676 15.8359L15.9584 7.82666C15.3578 7.22607 14.384 7.22607 13.7834 7.82666C13.7804 7.8296 13.7781 7.83284 13.7751 7.83578C13.778 7.83872 13.7803 7.84196 13.7833 7.8449Z",
    fill: "url(#paint27_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 21.2181L32.9172 13.3005H28.5671L26.0317 15.8359C25.4617 16.4059 24.5375 16.4059 23.9675 15.8359L21.4321 13.3005H17.082L24.9997 21.2181Z",
    fill: "url(#paint28_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0193 20.2376L24.9997 21.218L35.0414 11.1763H30.6913L26.0318 15.8358C25.4784 16.3892 24.5922 16.4036 24.0193 15.8825V20.2376Z",
    fill: "url(#paint29_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 22.3037C27.0301 22.3037 28.676 20.6578 28.676 18.6274C28.676 16.5971 27.0301 14.9512 24.9998 14.9512C22.9694 14.9512 21.3235 16.5971 21.3235 18.6274C21.3235 20.6578 22.9694 22.3037 24.9998 22.3037Z",
    fill: "url(#paint30_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 20.7351C26.1638 20.7351 27.1074 19.7914 27.1074 18.6274C27.1074 17.4634 26.1638 16.5198 24.9997 16.5198C23.8357 16.5198 22.8921 17.4634 22.8921 18.6274C22.8921 19.7914 23.8357 20.7351 24.9997 20.7351Z",
    fill: "url(#paint31_linear_4002_3188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 3.6601H14.1663C13.5438 3.6601 13.0391 3.15539 13.0391 2.53284V1.12725C13.0391 0.504706 13.5438 0 14.1663 0H35.8335C36.4559 0 36.9606 0.504706 36.9606 1.12725V2.53294C36.9606 3.15549 36.4559 3.6601 35.8334 3.6601Z",
    fill: "url(#paint32_linear_4002_3188)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4002_3188",
    x1: 7.60476,
    y1: 28.0936,
    x2: 10.8099,
    y2: 33.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4002_3188",
    x1: 8.05567,
    y1: 32.539,
    x2: 11.4756,
    y2: 33.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4002_3188",
    x1: 13.0872,
    y1: 22.7111,
    x2: 12.6379,
    y2: 30.6499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4002_3188",
    x1: 12.0668,
    y1: 26.7368,
    x2: 14.0058,
    y2: 30.3723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4002_3188",
    x1: 42.3874,
    y1: 28.1075,
    x2: 39.1823,
    y2: 33.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4002_3188",
    x1: 41.9364,
    y1: 32.5528,
    x2: 38.5165,
    y2: 33.8007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4002_3188",
    x1: 36.9047,
    y1: 22.725,
    x2: 37.354,
    y2: 30.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4002_3188",
    x1: 37.9251,
    y1: 26.7505,
    x2: 35.9861,
    y2: 30.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4002_3188",
    x1: 15.3876,
    y1: 24.7968,
    x2: 31.8304,
    y2: 41.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4002_3188",
    x1: 33.0711,
    y1: 42.4803,
    x2: 16.6933,
    y2: 26.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4002_3188",
    x1: 17.2441,
    y1: 26.6533,
    x2: 30.0105,
    y2: 39.4197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4002_3188",
    x1: 25,
    y1: 38.9708,
    x2: 25,
    y2: 49.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4002_3188",
    x1: 34.3374,
    y1: 42.5116,
    x2: 21.4615,
    y2: 34.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4002_3188",
    x1: 21.7523,
    y1: 31.4458,
    x2: 27.6088,
    y2: 37.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4002_3188",
    x1: 28.5091,
    y1: 33.0426,
    x2: 20.4147,
    y2: 36.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4002_3188",
    x1: 26.3956,
    y1: 35.915,
    x2: 21.964,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4002_3188",
    x1: 23.6043,
    y1: 35.915,
    x2: 28.0358,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4002_3188",
    x1: 23.7028,
    y1: 36.1373,
    x2: 26.5516,
    y2: 31.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4002_3188",
    x1: 26.0787,
    y1: 35.5591,
    x2: 25.8414,
    y2: 31.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4002_3188",
    x1: 32.6826,
    y1: 27.8227,
    x2: 26.6696,
    y2: 17.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4002_3188",
    x1: 25.6972,
    y1: 5.55637,
    x2: 29.5697,
    y2: 11.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4002_3188",
    x1: 21.8345,
    y1: -2.02167,
    x2: 33.8607,
    y2: 11.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4002_3188",
    x1: 19.2798,
    y1: 0.206101,
    x2: 31.3059,
    y2: 13.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4002_3188",
    x1: 24.9999,
    y1: 6.5195,
    x2: 24.9999,
    y2: 3.28088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4002_3188",
    x1: 28.7249,
    y1: 10.4905,
    x2: 30.3984,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4002_3188",
    x1: 21.2749,
    y1: 10.4905,
    x2: 19.6014,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4002_3188",
    x1: 33.4984,
    y1: 17.4128,
    x2: 13.3944,
    y2: -2.69108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4002_3188",
    x1: 24.9997,
    y1: 8.00647,
    x2: 24.9997,
    y2: 21.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4002_3188",
    x1: 24.9997,
    y1: 15.9802,
    x2: 24.9997,
    y2: 20.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4002_3188",
    x1: 29.6337,
    y1: 13.4242,
    x2: 26.8886,
    y2: 16.2183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4002_3188",
    x1: 22.8919,
    y1: 16.5196,
    x2: 28.0909,
    y2: 21.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4002_3188",
    x1: 26.4948,
    y1: 20.1225,
    x2: 23.9212,
    y2: 17.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4002_3188",
    x1: 24.9998,
    y1: 1.11108,
    x2: 24.9998,
    y2: 3.15402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4002_3188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronze-medal.cb1295a316db453c3fda282b9496ce2a.svg";
export { ForwardRef as ReactComponent };